import { Outlet } from "react-router-dom";
import { NavBarPublic } from "./NavBarPublic";
import FooterPublic from "./FooterPublic";
import { SponsorsBanner } from "./SponsorsBanner";

export function PublicLayout() {
  return (
    <>
      <NavBarPublic />
      <main>
        <Outlet />
      </main>
      <SponsorsBanner />
      <FooterPublic />
    </>
  );
}
